import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch'
import slugify from 'slugify'

import scrollManager from '../utils/scrollManager'
import customHits from '../utils/algolia/customHits'
import customCurrentRefinements from '../utils/algolia/customCurrentRefinements'
import { configure, refinementList, stats } from 'instantsearch.js/es/widgets'

export default {
  name: 'algolia-list',

  initialFacetsFilter: [],
  contactUrl: null,

  ui: {
    results: '[js-algolia-list-results]',
    tags: '[js-algolia-list-tags]',
    tags2: '[js-algolia-list-tags2]',
    'toggleFilters[]': '[js-algolia-list-toggle-filters]',
    filters: '[js-algolia-list-filters]',
    currentRefinements: '[js-algolia-list-current-refinements]',
    stats: '[js-algolia-list-stats]',
    pillars: '[js-algolia-list-pillars]',
  },

  events: [
    {
      on: 'click',
      target: 'toggleFilters',
      handle (e) {
        if (this.ui.filters.classList.contains('is-active')) {
          this.ui.filters.classList.remove('is-active')
          scrollManager.restart()

          if (e.target.classList.contains('panel-filters__close') && window.innerWidth < 768) {
            this.unsetFilters()
          }
        } else {
          this.ui.filters.classList.add('is-active')
          this.savedSearchState = this.search.renderState[`${this.search.indexName}`].currentRefinements.items

          setTimeout(() => {
            scrollManager.stop()
          }, 400)
        }
      },
    },
    {
      on: 'click',
      target: 'filters',
      handle (e) {
        if (e.target.classList.contains('panel-filters')) {
          this.ui.filters.classList.remove('is-active')
          scrollManager.restart()

          if (window.innerWidth < 768) {
            this.unsetFilters()
          }
        }
      },
    },
  ],

  componentDidMount () {
    const indexName = `${process.env.ALGOLIA_ENV}_pages`

    this.searchClient = algoliasearch(
      process.env.ALGOLIA_APP_ID,
      process.env.ALGOLIA_API_KEY,
    )

    if (this.props.contactUrl) {
      this.contactUrl = this.props.contactUrl
    }

    // get initials facets to avoid filter disapearing
    this.getInitFilters(this.props.filter)

    if (this.props.filter2) {
      this.getInitFilters(this.props.filter2)
    }

    this.search = instantsearch({
      indexName: `${indexName}`,
      searchClient: this.searchClient,
    })

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: window.innerWidth >= 1024 ? 9 : 6,
        facetFilters: [
          `type:${this.props.content}`,
          `locale:${this.props.locale}`,
          'status:published',
        ],
      }),
      // results
      customHits({
        container: this.ui.results,
        hasPaginate: this.props && this.props.hasPaginate,
        type: this.props.content,
        contactUrl: this.contactUrl,
      }),
      customCurrentRefinements({
        container: this.ui.currentRefinements,
      }),
      refinementList({
        container: this.ui.tags,
        attribute: this.props.filter,
        sortBy: ['name:asc'],
        transformItems: items => {
          return this.transformItems(items, 0)
        },
      }),
    ])

    if (this.ui.stats) {
      this.search.addWidgets([
        stats({
          container: this.ui.stats,
          templates: {
            text: `
            {{#hasNoResults}}0 ${this.ui.stats.dataset.singular}{{/hasNoResults}}
            {{#hasOneResult}}1 ${this.ui.stats.dataset.singular}{{/hasOneResult}}
            {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${this.ui.stats.dataset.plural}{{/hasManyResults}}
            `,
          },
        }),
      ])
    }

    if (this.props.filter2) {
      this.search.addWidgets([
        refinementList({
          container: this.ui.pillars,
          attribute: this.props.filter2,
          sortBy: ['name:asc'],
          transformItems: items => {
            return this.transformItems(items, 1)
          },
        }),
      ])
    }

    this.search.start()

    // update hitPerPage on resize
    window.addEventListener('orientationChange', event => {
      this.search.renderState[`${this.search.indexName}`].configure.refine({
        hitsPerPage: window.innerWidth >= 1024 ? 9 : 6,
        facetFilters: [
          `type:${this.props.content}}`,
          `locale:${this.props.locale}`,
          'status:published',
        ],
      })
    })

    // if parameters in URL
    const urlParams = new URLSearchParams(window.location.search)
    const pillarInUrl = urlParams.get('pillar')

    if (pillarInUrl) {
      this.search.renderState[`${this.search.indexName}`].refinementList.pillarName.refine(pillarInUrl)
    }

    setTimeout(() => {
      if (['medias', 'press-release', 'actuality'].includes(this.props.content) && typeof _paq !== 'undefined') {
        document.querySelectorAll('.ais-RefinementList-checkbox').forEach(filter => {
          filter.addEventListener('change', (e) => {
            if (e.target.checked) {
              const filter = slugify(e.target.nextElementSibling.innerHTML)

              if (this.props.content === 'medias') {
                _paq.push(['trackEvent', 'mediatheque', 'media', `filtre-mediatheque-${filter}`])
              } else if (this.props.content === 'press-release') {
                _paq.push(['trackEvent', 'communique-de-presse', 'newsroom', `filtre-presse-${filter}`])
              } else {
                _paq.push(['trackEvent', 'actualite', 'newsroom', `filtre-actualite-${filter}`])
              }
            }
          })
        })
      }
    }, 1500)
  },

  unsetFilters () {
    const searchState = this.search.renderState[`${this.search.indexName}`].refinementList

    // if filters saved compare and uncheck or checl items
    if (this.savedSearchState.length > 0) {
      this.savedSearchState.forEach(item => {
        const widget = searchState[item.attribute]

        widget.items.forEach(filterItem => {
          const inSavedSearch = item.refinements.filter(refinement => refinement.value === filterItem.value).length > 0
          if ((filterItem.isRefined && !inSavedSearch) || (!filterItem.isRefined && inSavedSearch)) {
            widget.refine(filterItem.value)
          }
        })
      })
    // if no filters saved, remove all checked items
    } else {
      Object.values(searchState).forEach(widget => {
        widget.items.forEach(filterItem => {
          if (filterItem.isRefined) {
            widget.refine(filterItem.value)
          }
        })
      })
    }
  },

  uniqBy (items, property) {
    const seen = {}

    return items.filter(item => {
      const val = item[property]

      if (seen[val]) {
        return false
      } else {
        seen[val] = true
        return true
      }
    })
  },

  getInitFilters (filter) {
    const initialFacetsFilter = []
    const indexName = `${process.env.ALGOLIA_ENV}_pages`

    this.searchClient.searchForFacetValues([
      {
        indexName,
        params: {
          facetName: filter,
          facetQuery: '',
          filters: `type:${this.props.content} AND locale:${this.props.locale}`,
        },
      },
    ])
      .then(([{ facetHits }]) => {
        initialFacetsFilter.push(
          ...facetHits.map(facet => ({
            ...facet,
            label: facet.value,
            value: facet.value,
            isRefined: false,
            count: 0,
          })),
        )
      })

    this.initialFacetsFilter.push(initialFacetsFilter)
  },

  transformItems (items, indexFilter) {
    this.initialFacetsFilter[indexFilter].forEach((facet, index) => {
      const updatedItem = items.find(item => item.value === facet.value)

      if (updatedItem) {
        this.initialFacetsFilter[indexFilter][index] = {
          ...updatedItem,
          count: 0,
        }
      }
    })

    let uniques = this.uniqBy([...items, ...this.initialFacetsFilter[indexFilter]], 'value').sort((a, b) => a.label.localeCompare(b.label))

    if (config.locale === 'fr') {
      uniques = uniques.map(item => item.label === 'video' ? { ...item, label: 'vidéo', highlighted: 'vidéo' } : item)
    }

    return uniques
  },
}
